// AUTO-GENERATED - Do not edit manually
// Run: node scripts/generate-contentful-defaults.mjs --locale=zh-CN to regenerate

export const alexGoReviewNote = {
  alex_go_review_note: null,
};
